var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c("modal", {
        staticClass: "annotations-panel",
        attrs: {
          show: _vm.showModal,
          showContent: _vm.showContent,
          pageTitle: _vm.title,
          acl: _vm.acl,
          url: _vm.url,
          closeBtn: _vm.closeBtn,
          position: "right",
          size: "small",
          id: "annotations-root",
        },
        on: { close: _vm.onCloseModal },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(" " + _vm._s(_vm.title)),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("annotation-grid", {
                    key: "features",
                    ref: "AnnotationsGrid",
                    attrs: {
                      moduleCode: _vm.moduleCode,
                      map: _vm.getMap(),
                      url: _vm.url,
                      reset: !_vm.showModal,
                      txtConfirmLeaveSession: _vm.txtConfirmLeaveSession,
                      readonlyFormItem: _vm.readonlyFormItem,
                      showHideCollection: true,
                      zoomToCollection: true,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1942444158
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }